import { isDefined } from "@core/utils";
import { initializer } from "@i18n/iprox";
import { Language } from "@shared/locales";

let i18n: ReturnType<typeof initializer>;
const initialize = (instance?: typeof i18n, ...args: Parameters<typeof initializer>) => {
  i18n = isDefined(instance) ? instance : initializer(...args);
};

export { i18n, initialize };

export const createButtonText = (t: typeof i18n.t, key: string) => {
  const label = t(key);

  return i18n.language === Language.Nederlands
    ? `+ ${label} toevoegen`
    : `+ Add ${label.charAt(0).toLowerCase() + label.slice(1)}`;
};
